import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule, FormsModule, InputTextModule],
    template: `
        <div class="menu-search">
            <i class="pi pi-search menu-search-icon"></i>
            <input
                #searchInput
                type="text"
                pInputText
                class="menu-search-input"
                placeholder="Search menu..."
                autocomplete="off"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange()"
            />
            <i class="pi pi-times menu-search-clear" *ngIf="searchTerm" (click)="clearSearch()"></i>
        </div>
        <ul class="layout-menu">
            <ng-container *ngFor="let item of filteredModel; let i = index">
                <li class="items" app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true" [forceExpand]="isSearching"></li>
                <li *ngIf="item.separator" class="menu-separator fill-black"></li>
            </ng-container>
        </ul>
        <div class="menu-no-results" *ngIf="isSearching && filteredModel.length === 0">
            <i class="pi pi-search"></i>
            <span>No menu items match "{{ searchTerm }}"</span>
        </div>
    `,
    styles: `
        .items {
            color: #ffffff !important;
        }
    `
})
export class AppMenu {
    @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;

    model: MenuItem[] = [];
    filteredModel: MenuItem[] = [];
    searchTerm = '';

    constructor(private readonly authService: AuthService) {
        this.authService.getMenuList().subscribe({
            next: (response: any) => {
                if (response.isSuccess) {
                    this.model = response.data ?? [];
                    localStorage.setItem('menuList', JSON.stringify(this.model));
                    this.applyFilter();
                } else {
                    console.error('Failed to load menu list:', response.errors);
                }
            }
        });
    }

    get isSearching(): boolean {
        return this.searchTerm.trim().length > 0;
    }

    onSearchChange(): void {
        this.applyFilter();
    }

    clearSearch(): void {
        this.searchTerm = '';
        this.applyFilter();
    }

    @HostListener('document:keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
            event.preventDefault();
            this.searchInputRef?.nativeElement?.focus();
        }
    }

    private applyFilter(): void {
        const term = this.searchTerm.trim().toLowerCase();
        this.filteredModel = term ? this.filterItems(this.model, term) : this.model;
    }

    private filterItems(items: MenuItem[], term: string): MenuItem[] {
        return items.reduce<MenuItem[]>((acc, item) => {
            if (item.separator) {
                return acc;
            }

            const labelMatch = !!item.label?.toLowerCase().includes(term);
            const filteredChildren = item.items ? this.filterItems(item.items, term) : undefined;

            if (labelMatch || (filteredChildren && filteredChildren.length > 0)) {
                acc.push({
                    ...item,
                    items: item.items ? (labelMatch ? item.items : filteredChildren) : undefined
                });
            }

            return acc;
        }, []);
    }
}
